import React, {useContext} from 'react'
import {StyledCommissionPanels} from './_styled'
import {CommissionContext} from '../../provider/_context'
import {CommissionPanel} from './_commissionPanel'

export const CommissionPanels = ({...props}) => {
    const {pageState} = useContext(CommissionContext)
    const {panels} = pageState

    return (
        <StyledCommissionPanels {...props}>
            <CommissionPanel
                className="order-panels__item"
                currency="đơn"
                title="Tổng số lượng đơn"
                value={panels?.total_orders || 0}
            />
            <CommissionPanel
                className="order-panels__item"
                currency="₫"
                title="Tổng doanh thu"
                value={panels?.total_revenue || 0}
            />
            <CommissionPanel
                className="order-panels__item"
                currency="₫"
                title="Tổng hoa hồng chênh lệch"
                value={panels?.total_differential_commission || 0}
            />
            <CommissionPanel
                className="order-panels__item"
                currency="₫"
                title="Tổng hoa hồng cho ĐL cấp 2"
                value={panels?.commission_teacher || 0}
            />
            <CommissionPanel
                className="order-panels__item"
                currency="₫"
                title="Tổng hoa hồng thực nhận"
                value={(+panels?.commission_principal + +panels?.total_differential_commission) || 0}
            />
        </StyledCommissionPanels>
    )
}
